import moment from 'moment';
import { useEffect, useState } from 'react';

// calculate time left
const getReturnValues = (countDown: number) => {
  const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return { hours, minutes, seconds };
};

function useCountdown(targetDate: string) {
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime());

  useEffect(() => {
    if (!moment(targetDate).isValid()) return;

    const interval = setInterval(() => setCountDown(countDownDate - new Date().getTime()), 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  if (!moment(targetDate).isValid()) return;

  return getReturnValues(countDown);
}

export default useCountdown;
